<template>
  <div class="product-details-content-draggable-items">
    <draggable
      :value="value"
      @input="val => $emit('input', val)"
      handle=".handle"
      :group="group"
    >
      <div
        v-for="(item, index) in value"
        class="position-relative"
        :key="index"
        :class="{ 'pb-5': index + 1 !== value.length }"
      >
        <svg height="0" width="33">
          <line
            x1="1"
            x2="1"
            y1="0"
            :y2="index + 1 === value.length ? 24.5 : '100%'"
            stroke="#cccee0"
          />
          <path
            fill="none"
            stroke="#cccee0"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M32 32.1579H9C4.58172 32.1579 1 28.5762 1 24.1579 M28 29L32.7 32.2 28 35"
          />
        </svg>
        <draggable-submodules-item
          v-if="item.type == 'submodule' || item.parent"
          :module="item"
          is-submodule
          @edit="subItem => $emit('edit', subItem)"
          @duplicate="subItem => $emit('duplicate', subItem)"
          @remove="subItem => $emit('remove', subItem)"
        />
        <button
          v-else
          class="w-100 card"
          :class="{ indicator: showListIndicator }"
          @click="goToRoute(item)"
        >
          <div class="draggable-item-body">
            <div class="d-flex align-items-center text-truncate flex-fill">
              <i class="icon-drag-indicator handle lead pl-2 pr-5"></i>
              <i
                v-if="item.type == 'quiz'"
                class="fa-solid fa-file-pen lead text-primary pr-3"
              ></i>
              <div class="d-flex flex-column flex-sm-row">
                <span
                  :contenteditable="editname"
                  @click.stop="onEditName"
                  @blur="e => onBlurName(index, e, item)"
                  spellcheck="false"
                  class="name text-wrap text-left pr-5 mr-5"
                >
                  {{ item.name }}
                </span>
                <span
                  class="status-badge"
                  :class="
                    item.status === 'draft' ? 'draft-badge' : 'published-badge'
                  "
                >
                  {{ item.status === "draft" ? "Rascunho" : "Publicada" }}
                </span>
              </div>
            </div>
            <div class="draggable-item-buttons pr-3 pr-md-0">
              <router-link
                :to="{
                  name: 'product-members-lesson-edit',
                  params: { id: $route.params.id, lesson: item.id }
                }"
                class="fs-12"
              >
                <button class="btn btn-sm btn-new-secondary p-3" title="Editar">
                  <i class="fa-light fa-pen"></i>
                </button>
              </router-link>
              <button
                v-if="item.type !== 'quiz'"
                class="btn btn-sm btn-new-secondary p-3"
                @click.stop="$emit('duplicate', item)"
                title="Duplicar"
              >
                <i class="fa-light fa-copy"></i>
              </button>
              <button
                class="btn btn-sm btn-new-secondary-danger p-3"
                @click.stop="$emit('remove', item)"
                title="Remover"
              >
                <i class="fa-light fa-trash"></i>
              </button>
            </div>

            <!-- <actions-dropdown
              class="d-sm-none"
              :left="false"
              :right="true"
              :actions="getActions(item)"
              toggleClass="p-0"
              @edit="$emit('edit', item)"
              @duplicate="$emit('duplicate', item)"
              @remove="$emit('remove', item)"
            >
              <template #button-custom-content>
                <i class="icon-more-vertical btn btn-sm" role="button"></i>
              </template>
            </actions-dropdown> -->
          </div>
        </button>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "draggable-items",
  components: {
    draggable,
    DraggableSubmodulesItem: () =>
      import("@/components/product/details/content/DraggableModulesItem.vue")
  },
  props: {
    value: Array,
    hideSubModules: Boolean,
    showListIndicator: Boolean,
    parent: {
      type: Object,
      default: () => {}
    },
    group: { type: String, default: "modules" }
  },
  data() {
    return {
      initialValue: this.value || [],
      loadingName: false,
      editname: false,
      collapsed: []
    };
  },
  methods: {
    getActions(item) {
      const target = item.type == "quiz" ? "avaliação" : "aula";
      return [
        {
          text: `Editar ${target}`,
          class: "",
          icon: "icon-filled-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        ...(item.type == "lesson"
          ? [
              {
                text: "Duplicar aula",
                class: "",
                icon: "icon-filled-clone",
                confirmation: {
                  enable: false
                },
                event: "duplicate"
              }
            ]
          : []),
        {
          text: `Excluir ${target}`,
          class: "text-danger",
          icon: "icon-filled-trash",
          confirmation: {
            enable: true,
            text: `Tem certeza que deseja excluir essa ${target}?`,
            newDesign: true,
            submitText: "Excluir",
            submitButtonClass: "btn-danger"
          },
          event: "remove"
        }
      ];
    },
    goToRoute(item) {
      if (this.editname) return;

      if (item.type == "quiz") {
        this.$router.push({
          name: "product-members-module-quizz-edit",
          params: {
            id: this.$route.params.id,
            module_id: this.parent.id,
            quizz_id: item.code
          }
        });
      }

      if (item.type == "lesson") {
        this.$router.push({
          name: "product-members-lesson-edit",
          params: {
            id: this.$route.params.id,
            lesson: item.id
          }
        });
      }

      return {};
    },
    onKeyDownName(e) {
      if (e.keyCode === 13 || e.which === 13) {
        e.preventDefault();
        this.editname = false;
        return false;
      }
    },
    onEditName() {
      this.editname = true;
      document.addEventListener("keydown", this.onKeyDownName);
    },
    onBlurName(index, e, item) {
      if (this.loadingName) return;

      let validation_map = {
        quiz: "O nome da avaliação não deve ter mais de 64 caracteres",
        lesson: "O nome da aula não deve ter mais de 240 caracteres"
      };

      let translated_type = item.type == "quiz" ? "avaliação" : "aula";

      if (!e.target.innerText.trim().length) {
        e.target.innerText = this.initialValue[index].name;
        this.$message.error(`O nome da ${translated_type} não pode ser vazio`);
      } else if (
        (item.type == "quiz" && e.target.innerText.length > 64) ||
        (item.type == "lesson" && e.target.innerText.length > 240)
      ) {
        e.target.innerText = this.initialValue[index].name;
        this.$message.error(validation_map[item.type]);
      } else {
        const action =
          item.type == "quiz" ? "membersQuizzes/put" : "membersLessons/put";
        let param = item.type == "quiz" ? "title" : "name";
        let params = { ...item, [param]: e.target.innerText };
        this.loadingName = true;
        this.$store
          .dispatch(action, params)
          .then(() => {
            this.initialValue[index].name = e.target.innerText;
            this.$message.success(
              `O novo nome da ${translated_type} foi salvo`
            );
          })
          .catch(error => {
            this.$message.error(error.response.data[param][0]);
            e.target.innerText = this.initialValue[index].name;
          })
          .finally(() => {
            this.loadingName = false;
          });
      }
      this.editname = false;
      document.removeEventListener("keydown", this.onKeyDownName);
    }
  }
};
</script>

<style lang="scss" scoped>
.product-details-content-draggable-items {
  .draggable-item-body {
    display: flex;
    align-items: center;
    padding: 16px 0px;
    width: 100%;
  }

  .draggable-item-buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    padding-right: 8px !important;
  }

  a,
  a:hover {
    text-decoration: none;
  }
  .icon-drag-indicator {
    cursor: pointer;
    color: var(--l-neutral-15, rgba(184, 186, 204, 0.86));

    &:active {
      cursor: grap;
    }
  }

  .fa-file-pen {
    font-size: 14px;
  }

  .btn-link {
    padding: 0;
  }

  small {
    font-size: 10px;
    line-height: 12px;
    display: block;
    color: #888;
  }

  .card {
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.16);
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.32);
    position: relative;

    &:hover {
      border: 1px solid rgba(207, 174, 255, 0.86);
    }
  }
  svg {
    @media screen and (max-width: 575px) {
      display: none;
    }

    top: 0;
    left: -51.51px;
    position: absolute;
    width: 33px;
    height: 100%;
  }

  .name {
    color: rgba(59, 59, 74, 0.9);
    font-size: 14px;
    font-weight: 400;
  }

  .icon-angle-down {
    font-size: 19px;
  }

  ::v-deep .btn-outline-dark {
    border: none;
    color: rgba(119, 120, 142, 0.87);
  }

  .status-badge {
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 12px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  .draft-badge {
    background-color: #fff3cd;
    color: #856404;
    border: 1px solid #ffc107;
  }

  .published-badge {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #28a745;
  }
}
</style>
